// Module
var code = "<md-icon class=\"md-accent md-28\" ng-class=\"{ expanded: vm.direction === 'up' }\"> expand_more </md-icon> ";
// Exports
module.exports = code;